module.exports = __webpack_public_path__ + "VAGRoundedStd-Bold.464addffb2947ca1836d.otf";


//////////////////
// WEBPACK FOOTER
// /var/www/minhaloga-cliente/src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.otf
// module id = ../../../../../src/app/@theme/fontes/fonte-vag-rounded/VAGRoundedStd-Bold.otf
// module chunks = styles